import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  align?: "left" | "center";
  tone?: "light" | "dark";
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  align = "center",
  tone = "light",
  className = "",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`${isCenter ? "mx-auto max-w-2xl text-center" : "text-left"} ${className}`}
    >
      {eyebrow && (
        <p className="mb-3 font-label text-sm font-medium uppercase tracking-[0.2em] text-accent-600">
          {eyebrow}
        </p>
      )}
      <h2
        className={`text-2xl font-bold leading-tight md:text-4xl ${
          tone === "dark" ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
    </div>
  );
}